import React, { FunctionComponent, memo } from "react";
import { Qualifiers } from "app/types/releases";
import ReleaseQualifiers from "app/components/ReleaseQualifiers";
import ProcultureLabel from 'app/components/release_item/ProcultureLabel';
import { checkHasNeedShowReleaseBadges, checkIsProCultureRelease } from "app/selectors/Helpers";
import {
	age0Icon,
	age6Icon,
	age12Icon,
	age14Icon,
	age16Icon,
	age18Icon,
	pushkinIcon,
	kinopoiskIcon
} from "app/constants/IconsConstants";
import Flex from "app/ui/Flex/Flex";
import { useSelector } from "react-redux";
import { getWithNewDesign } from "app/selectors/AppSelectors";

interface IProps {
	classes: string;
	qualifiers: Qualifiers[];
	withProCultureBadge?: boolean;
	isReleasePage?: boolean;
	wrapperElement?: FunctionComponent<{className?: string; classes?: string}> | keyof JSX.IntrinsicElements;
	ageRating?: string;
	kinopoiskRating?: number;
	withoutProCulture?: boolean;
};

const getAgeIcon = (ageRating: string) => {
	switch (ageRating) {
		case "0+":
			return age0Icon;
		case "6+":
			return age6Icon;
		case "12+":
			return age12Icon;
		case "14+":
			return age14Icon;
		case "16+":
			return age16Icon;
		case "18+":
			return age18Icon;
		default:
			return null;
	}
};

const ReleaseQualifiersWrapper = ({qualifiers, withProCultureBadge, classes, isReleasePage, wrapperElement = "div", ageRating, kinopoiskRating, withoutProCulture}: IProps) => {
	const withNewDesign = useSelector(getWithNewDesign);
	const isProCultureRelease = checkIsProCultureRelease({all_qualifiers: qualifiers});
	const isVisible = !!ageRating || !!kinopoiskRating || checkHasNeedShowReleaseBadges(qualifiers) || (isProCultureRelease && withProCultureBadge);

	return isVisible ? (
		React.createElement(
			wrapperElement,
			{
				classes,
				className: classes
			},
			(
				<>
					{ageRating ? getAgeIcon(ageRating) : null}
					{kinopoiskRating
						? <Flex alignItems="center" gap="4px">
							{kinopoiskIcon}
							{kinopoiskRating.toFixed(1)}
						</Flex>
						: null
					}
					{withNewDesign && !withoutProCulture && isProCultureRelease ? pushkinIcon : null}
					<ReleaseQualifiers
						qualifiers={qualifiers}
						isReleasePage={isReleasePage}
					/>
					{withProCultureBadge && isProCultureRelease ? <ProcultureLabel /> : null}
				</>
			)
		)
	) : null;
}

export default memo(ReleaseQualifiersWrapper);
